import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ProductBadge from '../../../components/library/badges/ProductBadge'
import Skeleton from '../../../components/library/loaders/Skeleton'
import './CaseBasicInformation'
import BackLink from '../../../components/library/common/BackLink';

const CaseTitle = (props) => {
    const { descEn, descFr, loading, lang } = props;

    const [header, setHeader] = useState('');

    useEffect(() => {
        var l = (lang || '').toUpperCase()
        setHeader((l !== 'FR' ? descEn : descFr) || '');
    }, [lang, descEn, descFr])

    return (
        <Fragment>
            <div className='columns tickets level'>
                <div className='column is-1'>
                    <ProductBadge productCode='OTE' />
                </div>
                <div className='column is-8'>
                    {!loading && 
                        <h1>{header || "—"}</h1>
                    }
                    {loading &&
                        <Skeleton />
                    }
                </div>
                <div className='column is-2'>
                    <BackLink isRight />
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns tickets level separator-border'>
                <div className='column is-1' />
                <div className='column is-10'>
                    <hr />
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

CaseTitle.whyDidYouRender = false;

CaseTitle.propTypes = {
    loading: PropTypes.bool,
    descEn: PropTypes.string,
    descFr: PropTypes.string
}

export default CaseTitle